import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Panel } from "@/components/KpiCard";
import { PlatformBadge } from "@/components/Badges";
import { api, errMsg, money } from "@/lib/api";

const today = () => new Date().toISOString().slice(0, 10);

const Ligne = ({ r }) => {
  const due = r.relance_date && r.relance_date <= today();
  return (
    <tr className="border-t border-slate-100" data-testid={`reclamation-row-${r.id}`}>
      <td className="py-2 pr-2"><span className="font-mono text-xs">{r.code}</span> <PlatformBadge plateforme={r.plateforme} />
        <p className="text-[11px] text-slate-500">{r.nom_client || r.logement} · {r.date}</p></td>
      <td className="py-2 px-2 text-right tabular font-semibold text-red-600" data-testid={`reclamation-montant-${r.id}`}>{money(r.montant_attendu)}
        {!r.saisi && <p className="text-[10px] font-normal text-slate-400">écart calculé</p>}</td>
      <td className={`py-2 pl-2 text-right tabular text-xs whitespace-nowrap ${due ? "text-amber-700 font-semibold" : "text-slate-600"}`} data-testid={`reclamation-relance-${r.id}`}>
        {r.relance_date ? <span className="inline-flex items-center gap-1"><CalendarClock className="h-3 w-3" />{r.relance_date}{due && " · à faire"}</span> : "—"}
      </td>
    </tr>
  );
};

export const ReclamationsPanel = ({ refreshKey }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/reclamations").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [refreshKey]);
  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-emerald-700" />;
  if (!data.items.length) return null;
  return (
    <Panel title={`Réclamations en cours · ${money(data.total)} attendus`} testId="reclamations-panel"
      action={<Link to="/reservations" className="text-xs text-emerald-700 hover:underline" data-testid="reclamations-see-all">Voir</Link>}>
      <table className="w-full text-sm">
        <thead><tr className="text-[11px] font-mono uppercase tracking-wider text-slate-500">
          <th className="pb-1 text-left">Réservation</th><th className="pb-1 text-right">Montant attendu</th><th className="pb-1 text-right">Relance</th>
        </tr></thead>
        <tbody>{data.items.map((r) => <Ligne key={r.id} r={r} />)}</tbody>
      </table>
      <p className="mt-2 text-[11px] text-slate-500">Une réclamation passe seule à « Régularisée » dès qu'un dépôt de la même plateforme, au cent près du montant réclamé, arrive sur le relevé.</p>
    </Panel>
  );
};
